/**
 * Slider Functionality
 *
 * @author Sadi Qevani
 */

(function (window, document, $) {
  "use strict";

  $(function () {

    $("#head-slider").unslider({
      autoplay: true,
      speed: 1500,
      delay: 7000,
      infinite: true
    });

  });

}(window, document, jQuery));
